<template>
	<div class="stations">
		<Station v-for="station in stations" :key="station.uuid" :station="station" @select="selectStation(station)" />
	</div>
</template>

<script>
import Station from './Station.vue';

export default {
	name: 'Stations',
	components: {
		Station,
	},
	computed: {
		station() {
			return this.$actions.getStation(this.$store.stationUuid);
		},
		stations() {
			return this.$actions.getStations();
		},
	},
	methods: {
		selectStation(station) {
            window.axios.post(`control/station/${station.uuid}`);
		},
	},
};
</script>

<style></style>
